import Api from '../../shared/services/api';

const baseUrl = "Rating";

export default {
  getByTrackingNumber(trackingNumber) {
    return Api().get(`${baseUrl}/details/${trackingNumber}`);
  }
};
